export default __webpack_public_path__ + "static/iso-certified.png";